import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { LoginPage } from '../auth/login-page';
import { safeNextPath } from '../lib/session/next-path';

/**
 * `/login?next=<path>` (M2.7, FR-ADMIN-01).
 *
 * `?next=` is validated twice - once here by `validateSearch`, and again by
 * `safeNextPath` before the navigation. The duplication is deliberate: this is the
 * screen that creates a session holding a clinic's patient records, which makes an open
 * redirect here worth finding.
 *
 * There is no tenant parameter and there will not be one. The clinic is the host
 * (ARCHITECTURE.md §4.1, rules §18.4); see `auth/login-page.tsx`.
 */
export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): { next?: string } => {
    const next = safeNextPath(search['next'], '');
    return next === '' ? {} : { next };
  },
  component: LoginRoute,
});

function LoginRoute() {
  const navigate = useNavigate();
  const { next } = Route.useSearch();

  return (
    <LoginPage
      onSignedIn={() => {
        void navigate({ to: safeNextPath(next), replace: true });
      }}
    />
  );
}
